// Minimal service worker registration -- trimmed from CRA's reference
// implementation (https://cra.link/PWA) to only what
// useServiceWorkerUpdate.ts needs: detecting a newly-installed, waiting
// service worker. No offline caching/precaching is involved. A no-op
// outside production builds and in browsers without SW support.

export type Config = {
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config): void {
  if (
    process.env.NODE_ENV !== 'production' ||
    !('serviceWorker' in navigator)
  ) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) return;

          installingWorker.onstatechange = () => {
            if (
              installingWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // A previous service worker already controlled this page, so
              // this is a genuinely new build, not the first-ever install.
              config?.onUpdate?.(registration);
            }
          };
        };
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
